module.exports = __webpack_public_path__ + "image/relevant_book_2_e3a41.png";